/**
 * View component for /user-answers/:userAnswerId
 *
 * Displays a single userAnswer from the 'byId' map in the userAnswer reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userAnswerActions from '../userAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userAnswer components
import UserAnswerLayout from '../components/UserAnswerLayout.js.jsx';

// import userAnswer css modules
import userAnswerStyles from '../userAnswerModuleStyles.css';


class SingleUserAnswer extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userAnswerActions.fetchSingleIfNeeded(match.params.userAnswerId));
  }

  render() {
    const { userAnswerStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual userAnswer object from the map
     */
    const selectedUserAnswer = userAnswerStore.selected.getItem();

    const isEmpty = (
      !selectedUserAnswer
      || !selectedUserAnswer._id
      || userAnswerStore.selected.didInvalidate
    );

    return (
      <UserAnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single User Answer </h3>
              {isEmpty ?
                (userAnswerStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userAnswerStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedUserAnswer.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE User Answer </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the UserAnswer would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </UserAnswerLayout>
    )
  }
}

SingleUserAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userAnswerStore: store.userAnswer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleUserAnswer)
);



// WEBPACK FOOTER //
// modules/userAnswer/views/SingleUserAnswer.js.jsx